import { render, staticRenderFns } from "./GoogleSighInSuccess.vue?vue&type=template&id=77be6790&"
import script from "./GoogleSighInSuccess.vue?vue&type=script&lang=js&"
export * from "./GoogleSighInSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports